"use client";

import { HeroSection } from "@/components/shared/public";
import { useTranslations } from "next-intl";
import { salesOptimizedFloorPlan } from "../../../../public/images/floor-plans";

const Hero = () => {
  const tC = useTranslations("common");
  const t = useTranslations("salesOptimizedFloorPlans.hero");

  return (
    <HeroSection
      image={salesOptimizedFloorPlan}
      alt={"Verkaufsoptimierter Grundriss"}
      tab={t("tab")}
      title={t("title")}
      text={t("text")}
      linkTitle={tC("optimizeNow")}
      href={"/login"}
      height={400}
    />
  );
};

export default Hero;
